import { Component, OnInit } from '@angular/core';
import { CrudServiceService } from 'src/app/services/crudService/crud-service.service';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-add-vaccine-group',
  templateUrl: './add-vaccine-group.component.html',
  styleUrls: ['./add-vaccine-group.component.scss']
})
export class AddVaccineGroupComponent implements OnInit {
  addForm : any;
  id : any;
  constructor(private crudService : CrudServiceService,
    private router : Router,
    private activatedRoute : ActivatedRoute) {
    this.addForm = {
     range : "",
     vaccineList :[{name :"" , number : 1  , type : 'Recomanded'}]
  } ;
  this.id = this.activatedRoute.snapshot.paramMap.get("id")
  if(this.id){
    this.crudService.getDedtail(this.id , environment.api.vaccineGroup).then((res)=>{
      this.addForm = res;
      console.log(this.addForm)
    })
  }

  }
  AddVaccine(){
    this.addForm.vaccineList.push({name : "" , number : this.addForm.vaccineList.length+1 , type : 'Recomanded'})
  }

  AddVaccineGroup(){
   if(this.addForm.range){

    if(this.id){
      this.crudService.edit(this.addForm , environment.api.vaccineGroup).then((res)=>{
        this.router.navigate(['/admin/vaccineGroup/list'])
        })
    }else{
      this.crudService.add(this.addForm , environment.api.vaccineGroup).then((res)=>{
        this.router.navigate(['/admin/vaccineGroup/list'])
        })
    }
 
   }
  }

  ngOnInit(): void {
  }
  removeIcon(i){
    this.addForm.vaccineList.splice(i,1);
  }
  

}
